<script>
  import StartBlock from "./StartBlock.svelte";
  import FlowSteps from "./FlowSteps.svelte";
  import {M} from "../../external";

  export let data;
  export let automation;
  export let draft;
  export let automationSave;

  let scale = 1;

  const zoomOut = () => {
    if (scale < 0.4) return;
    scale -= 0.1;
  };

  const zoomIn = () => {
    if (scale >= 1) return;
    scale += 0.1;
  };
</script>

<div class:show-visitors={!draft} class="automation-flow-wrapper" style={"transform: scale(" + scale + ");"}>
  <h4 class="col20 f-left t-center mb-25 roboto none">{M.AUTOMATION_START_MSG}</h4>
  <StartBlock bind:data={data.start} bind:repeat={data.repeat} />
  <FlowSteps bind:data={data.steps} {automation} {automationSave} rootFlow={true} />
</div>
<div class="zoom-controls">
  <a class:disabled={scale >= 1} class="material-icons rounded-effect" on:click={zoomIn}> add </a>
  <a class:disabled={scale < 0.4} class="material-icons rounded-effect" on:click={zoomOut}> remove </a>
</div>
